import { cn, useWizard } from '@restworld/utils-common';
import { Heading } from '@restworld/ui-ds-base';

import { FormInputProps } from '../../worker-application-wizard.types';
import {
  WizardInitialStep,
  WizardSecondStep,
  WizardThirdStep,
  WizardFourthStep,
  WizardFifthStep,
  WizardSixthStep,
  WizardSeventhStep,
  WizardEighthStep,
  WizardNinthStep,
  WizardTenthStep,
  WizardEleventhStep,
  WizardTwelfthStep,
  WizardThirteenth,
  WizardFourteenStep,
} from '../wizard-step.components';

export const WizardStepForm = ({ formHeaderTitle }: IWizardStepForm) => {
  const { activeStep } = useWizard();
  return (
    <WizardStepFormWrapper
      showScroll={[9, 2].includes(activeStep)}
      withBackground={activeStep !== 4 && activeStep !== 10}
      data-cy="wizard-step-form-wrapper"
    >
      <Heading>{formHeaderTitle}</Heading>
      <FormElements />
    </WizardStepFormWrapper>
  );
};
const FormElements = () => {
  const { activeStep, isFirstStep } = useWizard();
  if (isFirstStep) return <WizardInitialStep />; // 1 takes basic information such as name surname and email
  if (activeStep === 1) return <WizardSecondStep />; // 2 takes address information
  if (activeStep === 2) return <WizardThirdStep />; // 3 takes other basic information such as sex dob phone number communication channel
  if (activeStep === 3) return <WizardFourthStep />; // 4 takes fields such as driving license, user availability, displacement availability and preference
  if (activeStep === 4) return <WizardFifthStep />; // 5 takes confirmation to skip experience section
  if (activeStep === 5) return <WizardSixthStep />; // 6 experience section
  if (activeStep === 6) return <WizardSeventhStep />; // 7 education section
  if (activeStep === 7) return <WizardEighthStep />; // 8 certificate section
  if (activeStep === 8) return <WizardNinthStep />; // 9 language section
  if (activeStep === 9) return <WizardTenthStep />; // 10 upload picture section
  if (activeStep === 10) return <WizardEleventhStep />; // 11 research status key
  if (activeStep === 11) return <WizardTwelfthStep />; // 12 presentation letter
  if (activeStep === 12) return <WizardThirteenth />; // 13 research information section
  if (activeStep === 13) return <WizardFourteenStep />; // 14 social status link
  return null;
};
const WizardStepFormWrapper = ({
  withBackground,
  showScroll,
  className,
  ...props
}: { withBackground?: boolean; showScroll?: boolean } & React.HTMLAttributes<HTMLDivElement>) => (
  <div
    className={cn(
      'p-8 rounded-lg flex flex-col gap-4',
      withBackground && 'bg-primary-50',
      showScroll && 'md:h-full md:max-h-[36rem] md:overflow-y-auto',
      className
    )}
    {...props}
  />
);
type IWizardStepForm = FormInputProps;
